import type { AllRouteEndpoints } from "@dashboardApi/apis/routeTypes";

export const freeTrialValidateEmailKey = "/free_trial/validate_email";

export const freeTrialValidateEmailCacheKeys: AllRouteEndpoints[] = [freeTrialValidateEmailKey];
